module.exports = __webpack_public_path__ + "img/pyq.be569766.png";